import React, { useEffect, useState } from 'react';
// import styles from './index.module.scss';
import './style.scss';
import accountBg from '../../../assets/img/account-bg-new.png';
import gcloudZone from '../../../assets/img/gcloud-zone.png';
import { getLocalTime } from '../../../lib';
import { IAPIUserInfo } from '../../../model/api-modules';
import { AccountUsername } from './username';
import personalIconThree from '../../../assets/img/personal-icon-3.png';
import getFormatMessage from '../../../locales/get-format-message';
import { SvgIcon } from '../../component/svg-icon';
import { SvgIconName } from '../../component/svg-icon/model';
import { messageError, messageSuccess } from '../../../components/message';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import {
  createAccessToken,
  deleteAccessToken,
  getAccessToken,
} from '../../../api';
import moment from 'moment';
import { isSupportUser } from '../../lib';
import { isSupportSystem } from '../../../config';
import { reportPageError } from '../../lib/bk-report';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../store/reducers';

interface IProps {
  readonly onEditPassModal: () => void;
  readonly onDeleteAccountModal: () => void;
  readonly onDeleteSupportAccount: () => void;
  readonly userInfo: IAPIUserInfo;
  readonly username: string;
  readonly onReload: () => void;
}

export const AccountInfo = (props: IProps) => {
  const [isExpired, setIsExpired] = useState<boolean>(false);
  const [accessToken, setAccessToken] = useState<string>('');
  const [expiredTime, setExpiredTime] = useState<string>('');
  const userInfo = useSelector((state: IRootState) => state.common.userInfo);

  const createPersonalIcon = () => {
    return personalIconThree;
  };
  const renderHeaderBg = () => {
    return (
      <div>
        <img src={accountBg} className="accountBg" />
        <img src={gcloudZone} className="artZone" />
      </div>
    );
  };

  const renderAvatarName = () => {
    return (
      <div className="headSculptureBox">
        <div className="headSculpture">
          <img src={createPersonalIcon()} className="personalIcon" />
        </div>
        <AccountUsername username={props.username} onReload={props.onReload} />
      </div>
    );
  };

  const handleGetToken = async () => {
    const res = await getAccessToken();
    console.log('getAccessToken-res:', res);
    // 能获取到---没有失效
    if (res?.token) {
      setAccessToken(res.token);
      setIsExpired(false);
      // const expirationDate = getLocalTime(res.time + res.expired * 1000);
      let expirationDate = '2026-12-01 00:00:00';
      if (res.version) {
        expirationDate = getLocalTime(
          res.time + res.expired * 1000,
          userInfo?.UserSettings?.Timezone
        );
      }
      // 获取到过期时间
      setExpiredTime(expirationDate);
    } else {
      // 已经失效
      setIsExpired(true);
      setAccessToken('');
      setExpiredTime('');
    }
  };

  useEffect(() => {
    handleGetToken();
  }, [accessToken]);

  const handleGenerateToken = async () => {
    console.log('isExpired===', isExpired);
    if (isExpired) {
      const res = await createAccessToken();
      if (res) {
        const expirationDate = moment(res.time + res.expired * 1000)
          .utcOffset('+00:00')
          .subtract(8, 'hours')
          .format('YYYY-MM-DD HH:mm:ss');
        console.log('expirationDate', expirationDate);
        setAccessToken(res.token);
        setExpiredTime(expirationDate);
        setIsExpired(!isExpired); // 切换
      } else {
        messageError(getFormatMessage('create_fail'));
      }
    } else {
      // 点击使得accesstoken失效
      await deleteAccessToken();
      setAccessToken('');
      setExpiredTime('');
    }
  };

  const handleCopy = () => {
    navigator.clipboard
      .writeText(accessToken)
      .then(() => {
        messageSuccess(getFormatMessage('token_has_copied'));
      })
      .catch((error) => {
        console.error('复制token失败:', error);
        reportPageError(error);
      });
  };
  // 新div为挂载容器
  const tooltipContainer = document.createElement('div');
  tooltipContainer.classList.add('custom-tooltip-container');
  document.body.appendChild(tooltipContainer);

  const renderBasicInfo = () => {
    if (isSupportSystem()) {
      return (
        <>
          {/* <AccountUsername username={props.username} onReload={props.onReload} /> */}
          <RowWrap
            labelNode={getFormatMessage('email_address')}
            valueNode={props.userInfo.UserID}
          />

          <RowWrap
            labelNode={getFormatMessage('registration_time_local')}
            valueNode={getLocalTime(
              props.userInfo.CreateTime,
              userInfo?.UserSettings?.Timezone
            )}
          />

          <div className="lineAccount"></div>
          <RowWrap
            labelNode={
              <div className="deleteAccountDesc changePassword">
                {getFormatMessage('click_del_support_account_desc')}
                <span
                  className="deleteAccount"
                  onClick={props.onDeleteSupportAccount}
                >
                  {getFormatMessage('delete_account')}
                </span>
              </div>
            }
            valueNode={''}
          />
        </>
      );
    }
    return (
      <>
        {/* <AccountUsername username={props.username} onReload={props.onReload} /> */}
        <RowWrap
          labelNode={getFormatMessage('email_address')}
          valueNode={props.userInfo.Email}
        />
        <RowWrap
          labelNode={getFormatMessage('password')}
          valueNode={
            <p className="changePassword">
              <span className="changePasswordLeft">******************</span>
              {!isSupportUser() && (
                <span
                  className="changePasswordRight"
                  onClick={props.onEditPassModal}
                >
                  {getFormatMessage('change_password')}
                </span>
              )}
            </p>
          }
          // onClickRow={props.onEditPassModal}
        />
        <RowWrap
          labelNode={getFormatMessage('registration_time_local')}
          valueNode={getLocalTime(
            props.userInfo.CreateTime,
            userInfo?.UserSettings?.Timezone
          )}
        />
        {!isSupportUser() && (
          <div className="changePassword">
            <span>{getFormatMessage('access_token')}</span>
            {/* <span>{accessToken}</span> */}
            <span
              onClick={handleGenerateToken}
              className={`generateToken ${isExpired ? '' : 'expireRed'}`}
            >
              {isExpired
                ? getFormatMessage('generate_token')
                : getFormatMessage('expire_now')}
            </span>
          </div>
        )}
        {!isExpired && !isSupportUser() && (
          <div className="changePassword">
            <div className="changePasswordLeft" style={{ display: 'flex' }}>
              <span>******************</span>
              <SvgIcon
                icon={SvgIconName.Copy}
                className="action-icon pointer m-l"
                onClick={() => handleCopy()}
              />
            </div>
            <span className="changePasswordRight expireTime">
              {expiredTime}
              <Tooltip
                placement="topRight"
                title={getFormatMessage('the_token_will_expired_desc')}
                getPopupContainer={() => tooltipContainer}
                overlayClassName="accountTimeTooltip"
              >
                <QuestionCircleOutlined
                  style={{ marginLeft: 4, position: 'relative', top: -3 }}
                />
              </Tooltip>
            </span>
          </div>
        )}
        {!isSupportUser() && <div className="lineAccount"></div>}
        {!isSupportUser() && (
          <RowWrap
            // labelNode="Delete Account"
            labelNode={
              <div className="deleteAccountDesc changePassword">
                {getFormatMessage('click_del_account_desc')}
                <span
                  className="deleteAccount"
                  onClick={props.onDeleteAccountModal}
                >
                  {getFormatMessage('delete_account')}
                </span>
              </div>
            }
            valueNode={''}
          />
        )}
      </>
    );
  };

  return (
    <div className="accountCenter">
      <div className="viewBox">
        {renderHeaderBg()}
        {renderAvatarName()}
        <div className="contentBox">
          <div className="scrollableContent">{renderBasicInfo()}</div>
        </div>
      </div>
    </div>
  );
};

interface IRowWrap {
  readonly labelNode: React.ReactNode | string;
  readonly valueNode: React.ReactNode | string;
  readonly renderRightNode?: React.ReactNode | string;
  readonly onClickRow?: (
    event: React.MouseEvent<HTMLParagraphElement, MouseEvent>
  ) => void;
}
const RowWrap = (props: IRowWrap) => {
  return (
    <div className="blockBox">
      <p className="labelTitle">{props.labelNode}</p>
      <p className="showValue" onClick={props.onClickRow}>
        {props.valueNode}
      </p>
      {props.renderRightNode}
    </div>
  );
};
